const actionCreator = (type) => (payload = null, resolve = null, reject = null) => ({
    type,
    payload,
    resolve,
    reject
});

export default actionCreator;
